module.exports = __webpack_public_path__ + "static/media/km-ellipse.85c7a4a0.png";